import Vue from 'vue';
import Vuex from 'vuex';
import { readNotifstore } from './readNotifstore';  // Pastikan path sesuai

Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    readNotifstore,  // Tambahkan modul store di sini
  },
});

export default store;
